export default __webpack_public_path__ + "static/cadre_bois-1f6e6afa5a072252296a0acd3647ed79.png";